
export default {
  // Navigation-related translations
  "home": "Startseite",
  "profile": "Profil",
  "airports": "Flughäfen",
  "inventory": "Inventar",
  "admin": "Administrator",
  "regions": "Regionen",
  "airport": "Flughafen",
  "location": "Standort",
  "average_score": "Durchschnittliche Bewertung",
  "total_reviews": "Gesamtbewertungen",
  "rank": "Rang",
  "hand_check_success": "Handkontrolle Erfolg",
  "no_airports_found": "Keine Flughäfen in dieser Region gefunden",
  "develop": "Entwickeln",
  // "light_meter": "Belichtungsmesser" // Commented out to hide from navigation
};
